// extracted by css-extract-rspack-plugin
export default {"thumbsColumn":"_3ba4eb6a","thumbsList":"_ab36cade","displayContainer":"_4647a2f4","mainArrow":"_9044025b","printShow":"_83d461db","printHide":"_22cf2b38","printImage":"_41e76e3f"};